import "core-js/modules/es.json.stringify.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: _vm.loggedInAdmin.roles.includes("Unit Manager"),
      filterable: "",
      clearable: "",
      placeholder: "Select Unit Manager"
    },
    on: {
      change: _vm.fetchUnitList
    },
    model: {
      value: _vm.listQuery.adminId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "adminId", $$v);
      },
      expression: "listQuery.adminId"
    }
  }, _vm._l(_vm.unitManagers, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      disabled: !_vm.listQuery.adminId,
      placeholder: "Select Unit"
    },
    on: {
      change: _vm.getList
    },
    model: {
      value: _vm.listQuery.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "unitId", $$v);
      },
      expression: "listQuery.unitId"
    }
  }, _vm._l(_vm.unitList, function (unit) {
    return _c("el-option", {
      key: unit.id,
      attrs: {
        label: unit.name,
        value: unit.id
      }
    }, [_vm._v(" " + _vm._s(unit.name) + " - " + _vm._s(unit.code) + " ")]);
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      placeholder: "Search Product",
      disabled: !_vm.listQuery.unitId,
      clearable: "",
      remote: "",
      "reserve-keyword": "",
      "remote-method": _vm.fetchProductList
    },
    on: {
      change: _vm.getList
    },
    model: {
      value: _vm.listQuery.productId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "productId", $$v);
      },
      expression: "listQuery.productId"
    }
  }, _vm._l(_vm.productList, function (product) {
    return _c("el-option", {
      key: product.id,
      attrs: {
        label: product.name,
        value: product.id
      }
    }, [_vm._v(" " + _vm._s(product.catalogueCode) + " - " + _vm._s(product.name) + " ")]);
  }), 1), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "info",
      size: "mini",
      icon: "el-icon-search"
    },
    on: {
      change: _vm.handleFilter
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("router-link", {
    staticClass: "margin-horizontal",
    attrs: {
      to: "/inventory-inwards/add/"
    }
  }, [!_vm.isReadOnly && _vm.fromMumbaiBranch ? _c("el-button", {
    staticClass: "filter-item",
    attrs: {
      type: "warning",
      size: "mini",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " ")]) : _vm._e()], 1), !_vm.isReadOnly || _vm.isZonalManager ? _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.downloadData
    }
  }, [_vm._v(" Download ")]) : _vm._e(), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")])], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    key: _vm.tableKey,
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": "",
      "span-method": _vm.doProductRowSpan,
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "Product",
      prop: "productId",
      width: "350"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(`${scope.row.product_catalogue_code} - ${scope.row.product_name}`) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      align: "center",
      label: "Color",
      prop: "productsVariationId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.productsVariation_name) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Stock"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          staticStyle: {
            color: "#000000",
            "font-weight": "bold"
          },
          attrs: {
            type: scope.row.inventoryInward_currentStock > 0 ? "success" : scope.row.inventoryInward_currentStock < 0 ? "danger" : "warning",
            size: "medium"
          }
        }, [_vm._v(" " + _vm._s(scope.row.inventoryInward_currentStock) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Stock Value"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          staticStyle: {
            color: "#000000",
            "font-weight": "bold"
          },
          attrs: {
            type: scope.row.stockValue > 0 ? "success" : scope.row.stockValue < 0 ? "danger" : "warning",
            size: "medium"
          }
        }, [_c("inr", {
          attrs: {
            number: scope.row.stockValue
          }
        })], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [!_vm.isReadOnly && _vm.fromMumbaiBranch ? _c("el-button", {
          attrs: {
            type: "primary",
            icon: "el-icon-remove",
            size: "mini"
          },
          on: {
            click: function ($event) {
              return _vm.toggleDialog(scope.row);
            }
          }
        }) : _vm._e(), _c("router-link", {
          attrs: {
            to: {
              path: "/inventory-inwards/stock/",
              query: {
                query: JSON.stringify({
                  ..._vm.listQuery,
                  productId: scope.row.product_id,
                  variationId: scope.row.productsVariation_id
                })
              }
            }
          }
        }, [_c("el-button", {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            type: "success",
            icon: "el-icon-s-data",
            size: "mini"
          }
        })], 1)];
      }
    }])
  })], 1), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit,
      "page-sizes": [50, 100, 200, 500, 1000]
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  }), _c("el-dialog", {
    attrs: {
      title: "Inventory Remove",
      width: "80%",
      visible: _vm.dialogVisible,
      center: "",
      "destroy-on-close": true
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("inventory-remove", {
    key: `inventory-remove-${_vm.inventoryInwardId}`,
    attrs: {
      data: _vm.inventoryInwardData,
      "dialog-visible": _vm.dialogVisible
    },
    on: {
      "form-submit": _vm.handleDialog
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };